import { render, staticRenderFns } from "./ApiCallPlaceholder.vue?vue&type=template&id=70e81f7c&scoped=true&"
import script from "./ApiCallPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ApiCallPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ApiCallPlaceholder.vue?vue&type=style&index=0&id=70e81f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e81f7c",
  null
  
)

export default component.exports